import React, { Component } from "react";
import PropTypes from "prop-types";
import { Icon } from "antd";
import styles from "./ObservadorFormulariFotoSelectorImatge.module.css";
import { MIDA_MAX_FOTO_OBSERVADOR_BYTES } from "../../constantsFormularis";
import {
  extensionsPermesesEnString,
  fitxerTipusNoPermes
} from "../../utils/gestioImatges";

import {
  crearNotificacioFotoSuperaMidaPermesa,
  crearNotificacioFotoTipusNoPermes
} from "../../utils/notificacio";

const unitatImatge = "MB";

const converteixBytesAMB = midaEnBytes => {
  return (midaEnBytes / 1000 / 1000).toFixed(2);
};

const fitxerSuperaMidaMaximaPermesa = (midaFitxerEnMB, midaMaximaFotosEnMB) => {
  return midaFitxerEnMB > midaMaximaFotosEnMB;
};

class ObservadorFormulariFotoSelectorImatge extends Component {
  constructor(props) {
    super(props);

    this.modificarImatgeSeleccionada = this.modificarImatgeSeleccionada.bind(
      this
    );
    this.seleccionarImatge = this.seleccionarImatge.bind(this);
  }

  modificarImatgeSeleccionada(fitxer) {
    const midaMaximaFotosEnMB = converteixBytesAMB(
      MIDA_MAX_FOTO_OBSERVADOR_BYTES
    );
    const midaFitxerEnMB = converteixBytesAMB(fitxer.size);
    const tipusFitxer = fitxer.type;

    if (fitxerTipusNoPermes(tipusFitxer)) {
      crearNotificacioFotoTipusNoPermes();
      return;
    }

    if (fitxerSuperaMidaMaximaPermesa(midaFitxerEnMB, midaMaximaFotosEnMB)) {
      crearNotificacioFotoSuperaMidaPermesa(
        midaFitxerEnMB,
        unitatImatge,
        midaMaximaFotosEnMB
      );
      return;
    }

    const obtenirUrlImatgeSeleccionada = fitxer => {
      const reader = new FileReader();

      reader.onload = event => {
        const { crearFoto } = this.props;
        crearFoto({
          url: event.target.result,
          fitxer: fitxer
        });
      };
      reader.readAsDataURL(fitxer);
    };

    obtenirUrlImatgeSeleccionada(fitxer);
  }

  seleccionarImatge() {
    // si l'input té emmagatzemada una imatge, cal netejar-lo
    if (this.inputHTML5.value) {
      this.inputHTML5.value = "";
    }

    //es força un clic a l'element input d'HTML5
    this.inputHTML5.click();
  }

  render() {
    // input de tipus "file" d'HTML5, resta ocult però s'usa la funcionalitat de seleccionar arxiu
    const inputHTML5 = (
      <form method="POST" encType="multipart/form-data">
        <input
          ref={ref => (this.inputHTML5 = ref)}
          type="file"
          accept={extensionsPermesesEnString}
          onChange={event =>
            this.modificarImatgeSeleccionada(event.target.files[0])
          }
        />
      </form>
    );

    // zona que cal clicar quan es vol seleccionar una imatge
    const selectorImatge = (
      <div
        className={
          styles.ObservadorFormulariFotoSelectorImatgeContenidorImatgeAfegir
        }
        onClick={this.seleccionarImatge}
      >
        <Icon type="camera" style={{ fontSize: 25 }} />
      </div>
    );

    return (
      <div className={styles.ObservadorFormulariFotoSelectorImatge}>
        {inputHTML5}
        {selectorImatge}
      </div>
    );
  }
}

ObservadorFormulariFotoSelectorImatge.propTypes = {
  urlImatgeOriginal: PropTypes.string,
  accioCanviFoto: PropTypes.func,
  crearFoto: PropTypes.func
};

export default ObservadorFormulariFotoSelectorImatge;
